import React from 'react'
import { navigate } from 'gatsby'
import { Icon } from '@chakra-ui/icons'
import { Flex, Text } from '@chakra-ui/react'
import { FaExpand, FaAngleDoubleRight } from 'react-icons/fa'

import { ChatFieldsFragment } from '~graphql/generated/graphql'
import SharedStack from '~components/shared/wrappers/shared-stack'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import { UserRoutes } from '~config/routes'

interface Props {
    chat: ChatFieldsFragment
    onClose: () => void
}

export default function ChatClientInfoHeader({ chat, onClose }: Props) {
    return (
        <Flex
            flexDir="row"
            justifyContent="space-between"
            alignItems="center"
            pt={4}
            px={4}
            pb={3}
            borderBottomWidth={1}
            borderBottomColor="gray.200"
        >
            <Text fontSize="md" fontWeight="semibold">
                Client Details
            </Text>
            <SharedStack row fit>
                <IconButtonWithTooltip
                    icon={<Icon as={FaExpand} fontSize="sm" />}
                    label="View Full Details"
                    onClick={() =>
                        navigate(UserRoutes.ClientDetails(chat.client.id))
                    }
                    variant="outline"
                    size="xs"
                    h="28px"
                    w="28px"
                    rounded="full"
                />
                <IconButtonWithTooltip
                    icon={<Icon as={FaAngleDoubleRight} fontSize="sm" />}
                    label="Hide Client Info"
                    onClick={onClose}
                    variant="outline"
                    size="xs"
                    h="28px"
                    w="28px"
                    rounded="full"
                />
            </SharedStack>
        </Flex>
    )
}
